// extracted by mini-css-extract-plugin
export default {"layout":"e63617581b _0f3d39ec04 _73fed8ebfb","h_slide":"_61dea7dcb8","category":"_30335ce765 _03e2dc8e47 _5cb5ee2681"};